import React from "react";
import { Filter, List, Clock, CheckCircle, XCircle } from "lucide-react";

export type AppointmentStatusFilterType = "all" | "PENDING" | "APPROVED" | "REJECTED" | "CANCELLED";

interface AppointmentFilterProps {
  startDate: string | null;
  endDate: string | null;
  onDateChange: (startDate: string | null, endDate: string | null) => void;
  selectedStatus: AppointmentStatusFilterType;
  onStatusChange: (status: AppointmentStatusFilterType) => void;
}

export default function AppointmentStatusFilter({
  startDate,
  endDate,
  onDateChange,
  selectedStatus,
  onStatusChange,
}: AppointmentFilterProps) {
  const statusOptions = [
    {
      key: "all" as AppointmentStatusFilterType,
      label: "Tümü",
      icon: List,
    },
    {
      key: "PENDING" as AppointmentStatusFilterType,
      label: "Bekleyen",
      icon: Clock,
    },
    {
      key: "APPROVED" as AppointmentStatusFilterType,
      label: "Onaylanan",
      icon: CheckCircle,
    },
    {
      key: "REJECTED" as AppointmentStatusFilterType,
      label: "Reddedilen",
      icon: XCircle,
    },
    {
      key: "CANCELLED" as AppointmentStatusFilterType,
      label: "İptal Edildi",
      icon: XCircle,
    },
  ];

  return (
    <div className="pr-2 w-64">
      <div className="flex items-center justify-between mb-2">
        <div className="flex items-center gap-2">
          <Filter className="w-4 h-4 text-gray-600" />
          <span className="text-sm font-semibold text-gray-800">Filtreler</span>
        </div>
        <div className="flex items-center gap-1" />
      </div>

      <div className="space-y-4">
        <div>
          <label className="block text-xs font-medium text-gray-700 mb-2">Randevu Durumu</label>
          <div className="space-y-1">
            {statusOptions.map((option) => {
              const Icon = option.icon;
              const isSelected = selectedStatus === option.key;

              return (
                <button
                  key={option.key}
                  onClick={(e) => {
                    e.stopPropagation();
                    onStatusChange(option.key);
                  }}
                  className={`w-full flex items-center gap-2 px-3 py-2 rounded-md text-sm transition-colors text-left ${
                    isSelected ? "bg-blue-50 text-blue-700 border border-blue-200" : "text-gray-700 hover:bg-gray-100"
                  }`}>
                  <Icon className={`w-4 h-4 ${isSelected ? "text-blue-600" : "text-gray-500"}`} />
                  <span className="flex-1">{option.label}</span>
                </button>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
}
